import { useAllSearchParams } from 'storfox-route-hooks'
import { useCreate, useLimitedCountList } from 'storfox-api-hooks'

import { queryToParams } from '~/utils'
import * as API from '~/constants/api'

import { RetailerUnitFilterSerializer } from '../../serializers/RetailerUnit'

export const useUnitReportList = () => {
  const searchParams = useAllSearchParams()

  const params = queryToParams(RetailerUnitFilterSerializer, searchParams, 'guid')

  return useLimitedCountList(API.UNIT_NUMBER_LIST, params)
}

export const useRetailerUnitGenerate = () => {
  const searchParams = useAllSearchParams()
  const params = queryToParams(RetailerUnitFilterSerializer, searchParams, 'guid')
  const { create, ...state } = useCreate(API.RETAILER_UNIT_REPORT)

  return { ...state, export: () => create(params) }
}
